function toggleProductInfo() {
  const content = document.querySelector(".info-content-container");
  const icon = document.getElementById("chevronIcon");
  if (!content.style.maxHeight || content.style.maxHeight === "0px") {
    content.style.maxHeight = content.scrollHeight + "px";
    content.addEventListener("transitionend", function handler() {
      content.style.maxHeight = "none";
      content.removeEventListener("transitionend", handler);
    });
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    requestAnimationFrame(() => {
      content.style.maxHeight = "0px";
    });
  }
  content.classList.toggle("open");
  icon.classList.toggle("rotated");
}
function toggleProductOverview() {
  const content = document.querySelector(".overview-content-container");
  const icon = document.getElementById("chevronIconOverview");

  if (!content.style.maxHeight || content.style.maxHeight === "0px") {
    content.style.maxHeight = content.scrollHeight + "px";
    content.addEventListener("transitionend", function handler() {
      content.style.maxHeight = "none";
      content.removeEventListener("transitionend", handler);
    });
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    requestAnimationFrame(() => {
      content.style.maxHeight = "0px";
    });
  }
  content.classList.toggle("open");
  icon.classList.toggle("rotated");
}
window.addEventListener("DOMContentLoaded", () => {
  const openContainers = document.querySelectorAll(".slide-toggle.open");
  openContainers.forEach(container => {
    container.style.maxHeight = container.scrollHeight + "px";

    // Remove max-height after animation, if you want auto height afterward
    container.addEventListener("transitionend", function handler() {
      container.style.maxHeight = "none";
      container.removeEventListener("transitionend", handler);
    });
  });

  const content = document.getElementById("overviewContent");
  const link = document.getElementById("readMoreLink");
  if(content) {
    if (content.scrollHeight <= 300) {
      link.style.display = "none";
    } else {
      link.style.display = "block";
    }
  }
});
function toggleReadMore() {
  const content = document.getElementById("overviewContent");
  const link = document.getElementById("readMoreLink");
  content.classList.toggle("collapsed");
  link.innerText = content.classList.contains("collapsed") ? "Read more" : "Read less";
}

function setEqualHeights(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  let maxHeight = 0;

  // Reset to auto
  elements.forEach(el => el.style.height = 'auto');

  // Get max height
  elements.forEach(el => {
    if (el.offsetHeight > maxHeight) {
      maxHeight = el.offsetHeight;
    }
  });

  // Set to max height
  elements.forEach(el => el.style.height = maxHeight + 'px');
}

// Watch for content to appear
function runOnceWhenClassAppears(className, callback) {
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector(className)) {
      callback();
      obs.disconnect(); // Stop observing after first run
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}


runOnceWhenClassAppears('.card__heading', () => {
  setEqualHeights('.card__heading');
  setEqualHeights('.card-info-publisher');
  setEqualHeights('.card-info-isbn');
});
